import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { Box, Typography } from '@material-ui/core';
import { DateIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';

const useStyles = makeStyles((theme) => ({
  Picon: {
    color: '#5f9df6',
    width: '1.25rem',
    height: '1.375rem',
  },
  date: {
    display: 'flex',
    alignItems: 'start',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginRight: '0.625rem',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    marginTop: '0.5rem',
  },
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.919rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    margin: '0.5rem 0.5rem 0 0.625rem',
    display: 'flex',
    alignItems: 'center',
  },
  datepicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.5rem',
      backgroundColor: theme.palette.font.white,
      borderColor: '#e4e7eb',
      paddingLeft: '0.3rem',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.919rem',
      letterSpacing: '0',
      color: theme.palette.font.sub,
      fontWeight: '500',
      marginLeft: '-0.3rem',
      width: '96px',
      paddingRight: '0',
    },
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

export default function DateFilter({
  setStartDate,
  setEndDate,
  type,
  startDate,
  stopDate,
  errorMsg,
  startDatePickProps = {},
  stopDatePickProps = {},
}) {
  const classes = useStyles();
  const [selectedStartDate, handleStartDateChange] = useState(startDate);
  const [selectedEndDate, handleEndDateChange] = useState(stopDate);

  const handleSetStartDate = (props) => {
    if (props?.['_i'] && props?.['_i'][9] === '_') {
      return;
    }
    handleStartDateChange(props);
    if (props === null || moment(props).isValid()) {
      setStartDate(props ? moment(props) : null);
    }
  };

  const handleSetEndDate = (props) => {
    if (props?.['_i'] && props?.['_i']?.[9] === '_') {
      return;
    }
    handleEndDateChange(props);
    if (props === null || moment(props).isValid()) {
      setEndDate(props ? moment(props) : null);
    }
  };

  return (
    <div className={classes.date}>
      <div className={classes.label}>{i18n.t('BEDSTATUS_ADMISSION_DATE')}</div>
      <Box display="flex" flexDirection="column" id="bed_filter_time1">
        <KeyboardDatePicker
          id="bed_filter_time_input1"
          autoOk
          className={classes.datepicker}
          size="small"
          onChange={handleSetStartDate}
          keyboardIcon={<DateIcon className={classes.Picon} />}
          value={selectedStartDate}
          variant="inline"
          format="DD-MM-yyyy"
          inputVariant="outlined"
          InputAdornmentProps={{ position: 'start' }}
          placeholder={i18n.t('EHANDOVER_START_DATE')}
          invalidDateMessage={i18n.t('BEDSTATUS_INVALID_DATE_FORMAT')}
          {...startDatePickProps}
        />
        {errorMsg?.startDate ? <Typography className={classes.errorMsg}>{errorMsg.startDate}</Typography> : ''}
      </Box>
      <div className={classes.text}>-</div>
      <Box display="flex" flexDirection="column" id="bed_filter_time2">
        <KeyboardDatePicker
          id="bed_filter_time_input2"
          autoOk
          className={classes.datepicker}
          size="small"
          onChange={handleSetEndDate}
          keyboardIcon={<DateIcon className={classes.Picon} />}
          value={selectedEndDate}
          variant="inline"
          inputVariant="outlined"
          format="DD-MM-yyyy"
          InputAdornmentProps={{ position: 'start' }}
          placeholder={i18n.t('EHANDOVER_END_DATE')}
          invalidDateMessage={i18n.t('BEDSTATUS_INVALID_DATE_FORMAT')}
          {...stopDatePickProps}
        />
        {errorMsg?.stopDate ? <Typography className={classes.errorMsg}>{errorMsg.stopDate}</Typography> : ''}
      </Box>
    </div>
  );
}
